var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"leafLetContainer",attrs:{"id":"leafLetContainer"}}),_c('b-alert',{ref:"bAlert",attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }